import React, { useEffect, useState } from "react";
import { sendToAndroid } from "../services/androidBridge";
import { InputText } from "primereact/inputtext";
import {
  Banknote,
  Building2,
  ChevronRight,
  WalletCards,
} from "lucide-react";
import { Dropdown } from "./dropdown/Dropdown";
import "./Transfer.css";
import { GoAlertFill } from "react-icons/go";
import {
  language,
  transferListLanguageOptions,
} from "./dropdown/dropdown-data";

const Transfer = () => {
  const [amount, setAmount] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [accountList, setAccountList] = useState([]);

  const [confirmMessage, setConfirmMessage] = useState("notLoaded");
  const [successMessage, setSuccessMessage] = useState("notLoaded");
  const [jwt, setJwt] = useState();
  const [userName, setUserName] = useState("");
  const [donations, setDonations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [selectedAccountOrganization, setSelectedAccountOrganization] =
    useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const [title, setTitle] = useState();
  const [warning] = useState("");
  const [onConfirm, setOnConfirm] = useState("");
  const [transferRequest, setTransferRequest] = useState("");
  const [, setExtractedUrl] = useState("");
  const phoneNumber = {
    phoneNumber: "251946934699",
  };

  const [accountRequired, setAccountRequired] = useState("");
  const [organizationRequired, setOrganizationRequired] = useState("");
  const [amountRequired, setAmountRequired] = useState("");

  const [isFirst, setIsFirst] = useState(true);

  const handleFirstRender = (request) => {
    if (!isFirst) {
      sendDataToAndroid(request);
    }
    setIsFirst(false);
  };

  useEffect(() => {
    sendDataToAndroid("first");
    
    window.receiveDataFromAndroid = (data) => {
      var dataString = JSON.stringify(data);
      var obj = JSON.parse(dataString);

      if (JSON.parse(obj.request).name === "accountList") {
        
        if (
          obj.response !== undefined &&
          JSON.parse(obj.response).data !== undefined
        ) {
          let uniqueAccountList = [];
          JSON.parse(JSON.parse(obj.response).data).forEach((account) => {
           
            uniqueAccountList = [
              ...uniqueAccountList,
              { label: account.accounts, value: account.accounts },
            ];
            setAccountList([...uniqueAccountList]);
          });
        }
      }
      
      if (JSON.parse(obj.request).name === "confirmResponse") {
       
        setOnConfirm("true");
      } 
      
      if (JSON.parse(obj.request).name === "jwt") {
        setJwt(JSON.parse(obj.response).data);
      } 
      
      if (JSON.parse(obj.request).name === "response") {
        
        const urlFromResponse = JSON.parse(obj.request).url;
        setExtractedUrl(urlFromResponse);

        handleDataBasedOnUrl(urlFromResponse, JSON.parse(obj.response).data);
      } 
      
      if (JSON.parse(obj.request).name === "userName") {
        setUserName(JSON.parse(obj.response).data);
      }
    };
  }, []);
  
  const handleDataBasedOnUrl = (url, responseData) => {
    if (url.includes("InternalFundTransfer/rest/internalFundTransfer")) {
      const parsedResponse = JSON.parse(responseData);
      
      if (parsedResponse.status) {
        setSuccessMessage(parsedResponse.statusDesc);
        setErrorMessage("");
      } else {
        setErrorMessage(parsedResponse.statusDesc);
        setSuccessMessage("");
      }
      // setSuccessMessage(JSON.parse(responseData).statusDesc);
    } else if (url.includes("Donation/rest/donationList")) {
      const { donations, status } = JSON.parse(responseData);
      if (status === "found") {
        setDonations(donations);
        if (donations.length > 0) {
        }
      }
    } 
  };

  const handleTransfer = () => {
  

    !selectedAccount
      ? setAccountRequired("Please select an account")
      : setAccountRequired("");
    !selectedOrganization
      ? setOrganizationRequired("Please select an organization")
      : setOrganizationRequired("");
    !amount
      ? setAmountRequired("Please Enter the amount")
      : setAmountRequired("");

    if (!selectedAccount || !selectedOrganization || !amount) return;
    //   setWarning("All fields are required");

    const message =
      `<b>Donation name: </b> ${selectedOrganization} <br><br>` +
      `<b>Amount: </b> ${amount} <br><br>` +
      `<b>Reason</b> Donation <br><br>`;
    
    setTransferRequest({
      fromAccount: selectedAccount,
      fromAccountHolder: userName,
      toAccount: selectedAccountOrganization,
      toAccountHolder: selectedOrganization,
      amount: amount,
      remark: "Donation",
    });

    setConfirmMessage(message);
  };

  useEffect(() => {
    if(!isFirst) {
      
      setTitle(transferListLanguageOptions[jwt][0]);
    }
    setIsFirst(false)
  }, [jwt]);
  useEffect(() => {
    handleFirstRender("title");
  }, [title]);

  useEffect(() => {
    handleFirstRender("confirm");
  }, [confirmMessage]);
  useEffect(() => {
    handleFirstRender("success");
  }, [successMessage]);

  useEffect(() => {
    handleFirstRender("warning");
  }, [errorMessage]);

  useEffect(() => {
    handleFirstRender("openLoading");
  }, [loading]);

  useEffect(() => {
    handleFirstRender("openLoading");
    if (closeLoading) {
      setLoading(false);
      setCloseLoading(false);
    }
  }, [closeLoading]);

  useEffect(() => {
    handleFirstRender("warning");
  }, [warning]);

  useEffect(() => {
    if (onConfirm !== "") {
      handleFirstRender("request");
    } 
  }, [onConfirm]);

  useEffect(() => {
    sendDataToAndroid("donation");
  }, []);

  const sendDataToAndroid = (name) => {
    var transferData = {
      transferData: [],
    };
    if (name === "return") {
      transferData = {
        transferData: [
          {
            type: "return",
            request: { name: "graphData" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "title") {
      transferData = {
        transferData: [
          {
            type: "title",
            request: { name: "title" },
            response: { data: title },
            name: "",
          },
        ],
      };
    } else if (name === "first") {
      transferData = {
        transferData: [
          {
            type: "first",
            request: { name: "first" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "confirm") {
      transferData = {
        transferData: [
          {
            type: "confirm",
            request: { name: "confirm" },
            response: { data: confirmMessage },
            name: "",
          },
        ],
      };
    } else if (name === "openLoading") {
      transferData = {
        transferData: [
          {
            type: "openLoading",
            request: { name: "openLoading" },
            response: { data: loading },
            name: "",
          },
        ],
      };
    } else if (name === "closeLoading") {
      transferData = {
        transferData: [
          {
            type: "closeLoading",
            request: { name: "closeLoading" },
            response: { data: closeLoading },
            name: "",
          },
        ],
      };
    } else if (name === "warning") {
      transferData = {
        transferData: [
          {
            type: "warning",
            request: { name: "warning" },
            response: { data: errorMessage },
            name: "",
          },
        ],
      };
    } else if (name === "error") {
      transferData = {
        transferData: [
          {
            type: "error",
            request: { name: "error" },
            response: { data: errorMessage },
            name: "",
          },
        ],
      };
    } else if (name === "success") {
      transferData = {
        transferData: [
          {
            type: "success",
            request: { name: "success" },
            response: { data: successMessage },
            name: "",
          },
        ],
      };
    } else if (name === "request") {
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: { name: "InternalFundTransfer/rest/internalFundTransfer" },
            response: { data: JSON.stringify(transferRequest) },
            name: "",
          },
        ],
      };
    } else if (name === "donation") {
      transferData = {
        transferData: [
          {
            type: "requestPostNoLoading",
            request: { name: "Donation/rest/donationList" },
            response: { data: JSON.stringify(phoneNumber) },
            name: "",
          },
        ],
      };
    }
    sendToAndroid(transferData);
    setConfirmMessage("");
    setOnConfirm("");
    setErrorMessage("");
  };

  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [isOrganizationOpen, setIsOrganizationOpen] = useState(false);

  const handleIsAccountOpen = () => {
    setIsAccountOpen(!isAccountOpen);
    setIsOrganizationOpen(false);
  };

  const handleIsOrganizationOpen = () => {
    setIsOrganizationOpen(!isOrganizationOpen);
    setIsAccountOpen(false);
  };

  const handleOrganizationSelection = (option) => {
    const { organization, account_number } = option;
    setSelectedOrganization(organization);
    setSelectedAccountOrganization(account_number);
    handleIsOrganizationOpen();
  };

  const handleAccountSelection = (option) => {
    setSelectedAccount(option);
    handleIsAccountOpen();
  };

  return (
    <main className="service-screen transfer-page">
      <div className="w-full">
        <div className="space-y-5">
          {language[jwt]?.options?.map((option) => {
            const FieldIcon =
              option.type === "db"
                ? WalletCards
                : option.type === "org"
                ? Building2
                : Banknote;
            const fieldError =
              option.type === "db"
                ? accountRequired
                : option.type === "org"
                ? organizationRequired
                : amountRequired;

            return (
              <section key={option.label}>
                <label
                  className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700"
                  htmlFor={
                    option.type === "db"
                      ? "account"
                      : option.type === "org"
                      ? "organization"
                      : "amount"
                  }
                >
                  <FieldIcon
                    size={17}
                    className="text-[#0351b3]"
                    aria-hidden="true"
                  />
                  {option.label}
                </label>

                {option.type === "db" ? (
                  <Dropdown
                    options={accountList}
                    id="account"
                    placeholder={option.placeholder}
                    isOpen={isAccountOpen}
                    selectedAccount={selectedAccount}
                    selectedOrganization={selectedOrganization}
                    handleSelection={handleAccountSelection}
                    handleDropDown={handleIsAccountOpen}
                    setAccountRequired={setAccountRequired}
                  />
                ) : option.type === "org" ? (
                  <Dropdown
                    options={donations}
                    placeholder={option.placeholder}
                    id="organization"
                    isOpen={isOrganizationOpen}
                    selectedAccount={selectedAccount}
                    selectedOrganization={selectedOrganization}
                    handleSelection={handleOrganizationSelection}
                    handleDropDown={handleIsOrganizationOpen}
                    setOrganizationRequired={setOrganizationRequired}
                  />
                ) : (
                  <div className="relative">
                    <span className="pointer-events-none absolute right-3 top-3 text-sm font-semibold text-slate-400">
                      Birr
                    </span>
                    <InputText
                      id="amount"
                      type="number"
                      min="0"
                      inputMode="decimal"
                      value={amount}
                      onChange={(e) => {
                        setAmount(e.target.value);
                        setAmountRequired("");
                      }}
                      className={`transfer-control pr-14 ${
                        fieldError ? "transfer-control-error" : ""
                      }`}
                    />
                  </div>
                )}

                {fieldError && (
                  <p className="transfer-error" role="alert">
                    <GoAlertFill aria-hidden="true" />
                    {option.error}
                  </p>
                )}
              </section>
            );
          })}

          {jwt !== undefined && (
            <button
              type="button"
              onClick={handleTransfer}
              className="transfer-primary-button"
            >
              <span>{language[jwt]?.button}</span>
              <ChevronRight size={18} aria-hidden="true" />
            </button>
          )}
        </div>
      </div>
    </main>
  );
};

export default Transfer;
